export default {
  computed: {
    // 文字数が多い言語はsmall-text属性を追加して文字サイズを小さくする
    isLongLang() {
      const longLangs = ['ru', 'de', 'nl']
      return longLangs.includes(this.$i18n.locale)
    }
  }
}
